/* BSFA — Fix: gallery/thumbnails swiper si taglia dopo navigazione, si risolve solo con reload.
   Causa: gli swiper con autoHeight calcolano l'altezza nell'istante dell'init, ma se le
   immagini non hanno ancora finito di caricare/decodificare la misura resta bloccata
   (contenuto tagliato) e non viene mai ricalcolata finche' non si ricarica la pagina
   (le immagini arrivano dalla cache e sono gia' pronte). Qui ricalcoliamo l'altezza degli
   swiper ogni volta che un'immagine della galleria finisce di caricare, dopo il load della
   pagina e dopo un cambio sezione (Shopify section rendering / quick view). */
(function () {
  'use strict';

  function refreshSwipers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.m-product-media--slider__images .swiper-container, .m-product-media--slider__thumbnails .swiper-container, .nav-swiper-container').forEach(function (el) {
      var inst = el.swiper;
      if (!inst) return;
      try { if (typeof inst.updateAutoHeight === 'function') inst.updateAutoHeight(0); } catch (e) {}
      try { if (typeof inst.update === 'function') inst.update(); } catch (e) {}
    });
  }

  function onImgLoad(img) {
    refreshSwipers(img.closest('.m-product-media') || img.closest('.m-main-product--media') || document);
  }

  function bindImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.m-main-product--media img, .m-product-media--mobile img, .m-product-media--slider__thumbnails img').forEach(function (img) {
      if (img.hasAttribute('data-bsfa-swiper-bound')) return;
      img.setAttribute('data-bsfa-swiper-bound', '');
      if (img.complete) {
        onImgLoad(img);
      } else {
        img.addEventListener('load', function () { onImgLoad(img); });
      }
    });
  }

  function init() {
    bindImages();
    refreshSwipers();

    window.addEventListener('load', function () {
      refreshSwipers();
      setTimeout(refreshSwipers, 300);
      setTimeout(refreshSwipers, 800);
    });

    // Shopify AJAX section re-render (quick view, section rendering API, ecc.)
    document.addEventListener('shopify:section:load', function (e) {
      bindImages(e.target);
      refreshSwipers(e.target);
      setTimeout(function () { refreshSwipers(e.target); }, 300);
    });

    // Rete di sicurezza extra: ricalcola ancora un paio di volte nei primi istanti,
    // utile per connessioni piu' lente dove le immagini arrivano in ritardo.
    setTimeout(refreshSwipers, 1200);
    setTimeout(refreshSwipers, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
